import { formatStructuredAddress } from '@utils/formatStructuredAddress';
import { provinceSlugToAbbreviation } from '@utils/provinceSlugToAbbreviation';
import type { ResolvedAddress } from '@t/address.types';
import type { ManualAddressValues } from './ManualAddressEntry.types';

/**
 * A hand-typed address has no vendor behind it, so `formattedAddress` and
 * `displayAddress` are the same composed string — there is no vendor rendering to
 * preserve separately.
 */
export const toResolvedAddress = (values: ManualAddressValues): ResolvedAddress => {
  const unitNumber = values.unitNumber.trim();
  const fields = {
    streetNumber: values.streetNumber.trim(),
    streetName: values.streetName.trim(),
    city: values.city.trim(),
    province: provinceSlugToAbbreviation(values.state?.value ?? ''),
    postalCode: values.postalCode.trim().toUpperCase(),
  };
  const display = formatStructuredAddress({ ...fields, unitNumber, country: 'Canada' });

  return {
    ...fields,
    ...(unitNumber ? { unitNumber } : {}),
    country: 'CA',
    formattedAddress: display,
    displayAddress: display,
  };
};
